module.exports = __webpack_public_path__ + "components/flag/static/square/bv-5fcd1c3a7bb69915d1190cf658c77ff8.svg";